  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
//import Checkbox                                            from '@material-ui/core/Checkbox';
//import Radio                                               from '@material-ui/core/Radio';
//import RadioGroup                                          from '@material-ui/core/RadioGroup';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  import Typography                                          from '@material-ui/core/Typography';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
  import InputLabel                                          from '@material-ui/core/InputLabel';
  import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
  import FormControl                                         from '@material-ui/core/FormControl';
  import Select                                              from '@material-ui/core/Select';
  import Autocomplete                                        from '@material-ui/lab/Autocomplete';
  import { createFilterOptions }                             from '@material-ui/lab/Autocomplete';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //[POPOVER]
//import Popover                                             from '@material-ui/core/Popover';
//import IconButton                                          from '@material-ui/core/IconButton';
//import InputAdornment                                      from '@material-ui/core/InputAdornment';
//import Typography                                          from '@material-ui/core/Typography';
//import InfoIcon                                            from '@material-ui/icons/Info';
  //-------------------
  // @material-ui/icons
  //-------------------
//import CardTravel                                          from "@material-ui/icons/CardTravel";
//import Extension                                           from "@material-ui/icons/Extension";
//import Fingerprint                                         from "@material-ui/icons/Fingerprint";
//import FlightLand                                          from "@material-ui/icons/FlightLand";
//import Build                                               from "@material-ui/icons/Build";
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //----------
  // Libraries
  //----------
//import TagManager                                          from 'react-gtm-module'
//import ReCAPTCHA                                           from "react-google-invisible-recaptcha";
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_CountriesStatesCitiesService }                 from "../../_services";
  import { wu_IdentityCardsService }                         from "../../_services";
//import { wu_TransactionFlow }                              from "../../_services";
  import { wu_ProfileService }                               from "../../_services";
//import { wu_GeolocationService }                           from "../../_services";
  import { wu_RegisterGOVService }                           from "../../_services";
  import { wu_RegisterIdBoxService }                         from "../../_services";
  //------
  // Style
  //------
  import RegisterLight3Style                                      from "./RegisterLight3Style.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
//import img2                                                from "assets/img/wu/testImg2.png";
  import KeyboardBackspaceIcon                               from '@material-ui/icons/KeyboardBackspace'; //[goBack]
  //----------
  // variables
  //----------
  const filename = "RegisterLight3 ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  //[flagsimages]
  var images = null;

class RegisterLight3 extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      //[HONEYMOON]
      textField0                                           : "", //4279034659
      textField0_hasError                                  : false,

      idIssuingCountry_id                                  : "",               //DropDown
      idIssuingCountry_text                                : "",
      idIssuingCountry_disabled                            : false,
      idIssuingCountry_hasError                            : false,
      idIssuingCountry_AUTOCOMPLETE_MODE                   : "object", //"text","object";
      idIssuingCountry_AUTOCOMPLETE_FILTER_OPTIONS         : "any",    //"start","any"
      idType_text                                          : "",               //DropDown
      idType_id                                            : "",
      idType_disabled                                      : false,
      idType_hasError                                      : false,
      idType_idBox_kyc                                     : false,
      idType_idBox_kyc_isNull                              : false,
      idNumber                                             : "",               //TextField
      idNumber_disabled                                    : false,
      idNumber_hasError                                    : false,

      parserObject_getCountries                            : [],
      parserObject_getCountries4Picker                     : [],
      parserObject_getIdTypes_el                           : [],
      parserObject_getIdTypes_en                           : [],
      parserObject_getIdTypes4Picker_el                    : [],
      parserObject_getIdTypes4Picker_en                    : [],
      parserObject_getPhonePrefixes                        : [],
      parserObject_getPhonePrefixes4Picker                 : [],

      btn_confirm_isHidden                                 : true,
      btn_changeId_isHidden                                : true,
      btn_store_isHidden                                   : true,
      btn_egov_isHidden                                    : true,
      btn_next_isHidden                                    : true,

      redirectURL                                          : "", //GOV info
      languageCode                                         : "",
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                 = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                = this.dialog_handleClose.bind(this);
    this.startSpinners                                     = this.startSpinners.bind(this);
    this.stopSpinners                                      = this.stopSpinners.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                              = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                             = this.dialog200_handleClose.bind(this);

    //[goBack]
    this.goBack                                            = this.goBack.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                     = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                    = this.Snackbar_textField_handleClose.bind(this);

    this.btn_confirm_act                                   = this.btn_confirm_act.bind(this);
    this.btn_confirm_act_isDisabled                        = this.btn_confirm_act_isDisabled.bind(this);

    this.btn_changeId_act                                  = this.btn_changeId_act.bind(this);
    this.btn_changeId_act_isDisabled                       = this.btn_changeId_act_isDisabled.bind(this);

    this.btn_egov_act                                      = this.btn_egov_act.bind(this);
    this.btn_egov_act_isDisabled                           = this.btn_egov_act_isDisabled.bind(this);

    this.btn_store_act                                     = this.btn_store_act.bind(this);
    this.btn_store_act_isDisabled                          = this.btn_store_act_isDisabled.bind(this);

    this.btn_next_act                                      = this.btn_next_act.bind(this);
    this.btn_next_act_isDisabled                           = this.btn_next_act_isDisabled.bind(this);

    this.handleSubmit_with_recaptcha                       = this.handleSubmit_with_recaptcha.bind(this);
    this.recaptchaRef                                      = React.createRef();

    this.handleCustomDropDownClick_idIssuingCountry        = this.handleCustomDropDownClick_idIssuingCountry.bind(this);
    this.handleCustomDropDownClick_idType                  = this.handleCustomDropDownClick_idType.bind(this);

    this.buttons_show_hide                                 = this.buttons_show_hide.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view")); if(api.print_logs){console.log(methName+localStorage.getItem("prev_view"));}
    localStorage.setItem("curr_view", filename);                          if(api.print_logs){console.log(methName+localStorage.getItem("curr_view"));}

    if(localStorage.getItem("lang")!=='el' && localStorage.getItem("lang")!=='en'){ localStorage.setItem("lang","el"); }

    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){
        //++++++++++++
        //Login Screen
        //++++++++++++
        wu_Utilities.LogoutUserFromApp(filename);
        history.push(wu_Utilities.getNavigationURLs("LoginPage"));
        return;
      }
    }

    //[flagsimages]
    images = this.importAll(require.context('assets/img/flagspng/', false, /\.(png|svg)$/));
    //if(api.print_logs){console.log("images.length="+images.length);}
    //for (var key in images) { if(api.print_logs){console.log("key="+key);} }

    if(localStorage.getItem("prev_view").trim()==="RegisterLight4"){
      try{ this.setState(JSON.parse(localStorage.getItem(filename.trim()))); }catch(err){;}
      this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      return;
    }

    //this.startSpinners();
    //------------
    //getCountries---CACHED
    //------------
    let retrieveWSData_getCountries = wu_CountriesStatesCitiesService.wu_should_getCountries();
    if(retrieveWSData_getCountries){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_CountriesStatesCitiesService
      .wu_getCountries({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="RegisterLight3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        let parserObject_getCountries4Picker = [];
        //res.countries = this.removeNonWuCountries(res.countries);
        res.countries = wu_Utilities.addKeywordsToJSON_test(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      })
      .catch(err => {
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        console.log(methName+"err="+JSON.stringify(err));
        let res = wu_StaticDataService.wu_get_cached_countries({});
        var parserObject_getCountries4Picker= [];
        //res.countries = this.removeNonWuCountries(res.countries);
        res.countries = wu_Utilities.addKeywordsToJSON_test(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker,
        });
      });
    }
    else{
      try{
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        let res = JSON.parse(localStorage.getItem("countries"));
        var parserObject_getCountries4Picker= [];
        //res.countries = this.removeNonWuCountries(res.countries);
        res.countries = wu_Utilities.addKeywordsToJSON_test(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      }catch(err){
        console.log('err='+err);
      }
    }
    //-------------------
    //wu_getPhonePrefixes---STATIC
    //-------------------
    var res_obj_getPhonePrefixes = wu_StaticDataService.wu_getPhonePrefixes({});
    var parserObject_getPhonePrefixes4Picker = [];
    let descKey_phonePrefixes = localStorage.getItem("lang")==="el" ? "descr_el" : "descr_en";
    for(let i=0; i<res_obj_getPhonePrefixes.phone_prefixes.length; ++i){ parserObject_getPhonePrefixes4Picker.push(res_obj_getPhonePrefixes.phone_prefixes[i][descKey_phonePrefixes]); }
    this.setState({
      "parserObject_getPhonePrefixes"        : res_obj_getPhonePrefixes.phone_prefixes,
      "parserObject_getPhonePrefixes4Picker" : parserObject_getPhonePrefixes4Picker,
    });

    if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
    //-------------------
    //wu_validatecustomer
    //-------------------
    wu_ProfileService
    .wu_validatecustomer({})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="RegisterLight3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));

      let parserObject_validatecustomer = {};
      try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
      var idVerificationStatus = 0;
      try {idVerificationStatus = parserObject_validatecustomer["idVerificationStatus"]; }catch(err){;} if(idVerificationStatus === null){idVerificationStatus = 0;}

      let btn_confirm_isHidden = true;
      let btn_store_isHidden   = true;
      let btn_egov_isHidden    = true;
      let btn_next_isHidden    = true;
      if(idVerificationStatus === 0){
        btn_confirm_isHidden = true;
        btn_store_isHidden   = true;
        btn_egov_isHidden    = true;
        btn_next_isHidden    = true;
      }
      else{
        btn_confirm_isHidden = false;
        btn_store_isHidden   = true;
        btn_egov_isHidden    = true;
        btn_next_isHidden    = true;
      }

      let ws_idnum   = "";
      let ws_id_ctry = "";
      let ws_idtype  = "";
      try {ws_idnum   = res.customer["idnum"];   }catch(err){;} if(ws_idnum   === null || (typeof ws_idnum   ==="undefined")){ws_idnum   = "";}
      try {ws_id_ctry = res.customer["id_ctry"]; }catch(err){;} if(ws_id_ctry === null || (typeof ws_id_ctry ==="undefined")){ws_id_ctry = "";}
      try {ws_idtype  = res.customer["idtype"];  }catch(err){;} if(ws_idtype  === null || (typeof ws_idtype  ==="undefined")){ws_idtype  = "";}

      //XYZ
      var newRegistrationFlow = "";
      try { newRegistrationFlow = localStorage.getItem("newRegistrationFlow"); } catch(err){;}
      let parserObject_updateCustomerData_req = {};
      try{ parserObject_updateCustomerData_req = JSON.parse(localStorage.getItem("parserObject_updateCustomerData_req"));}catch(err){console.log(methName+'err='+err);}
      if(idVerificationStatus !== 1){
        if(newRegistrationFlow === "newCustomer")   { ws_id_ctry = ""; ws_idnum = parserObject_updateCustomerData_req["idnum"]; }
        if(newRegistrationFlow === "upgradeAccount"){ ws_id_ctry = ""; ws_idnum = parserObject_updateCustomerData_req["idnum"]; }
        if(newRegistrationFlow === "changeId")      { ws_id_ctry = ""; ws_idnum = parserObject_updateCustomerData_req["idnum"]; }
      }
      this.setState({
        idIssuingCountry_id                                  : ws_id_ctry,
        idIssuingCountry_text                                : this.state.idIssuingCountry_AUTOCOMPLETE_MODE==="text" ? wu_Utilities.findCountryNameFromCountryId(ws_id_ctry,localStorage.getItem("lang")) : wu_Utilities.findCountryObjFromCountryId(ws_id_ctry,localStorage.getItem("lang")),
        idType_id                                            : "",
        idType_text                                          : "", //DropDown
        idType_hasError                                      : false,
        idType_idBox_kyc                                     : false,
        idType_idBox_kyc_isNull                              : false,
        "idNumber"                                           : ws_idnum,

        btn_confirm_isHidden                                 : btn_confirm_isHidden,
        btn_store_isHidden                                   : btn_store_isHidden,
        btn_egov_isHidden                                    : btn_egov_isHidden,
        btn_next_isHidden                                    : btn_next_isHidden,
      });

      this.makeHTTPConn_select_COUNTRY_reload_IDTYPE_select_IDTYPE(ws_id_ctry,ws_idtype);
    })
    .catch(err => {
      this.stopSpinners();
      console.log(methName+"err="+JSON.stringify(err));
      if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
      else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
    });
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    //-------
    //Country
    //-------
    let defaultPropsCountry  = {};
    let filterOptionsCountry = {};
    if(this.state.idIssuingCountry_AUTOCOMPLETE_MODE === "text"){
      defaultPropsCountry  = { options:this.state.parserObject_getCountries4Picker, getOptionLabel:option => option,};
      filterOptionsCountry = createFilterOptions({matchFrom: this.state.idIssuingCountry_AUTOCOMPLETE_FILTER_OPTIONS, stringify: option => option, });
    }
    else{
      if(localStorage.getItem("lang")==="en"){ defaultPropsCountry = { options:this.state.parserObject_getCountries, getOptionLabel:option => option.descr_en ? option.descr_en : "", }; }
      else                                   { defaultPropsCountry = { options:this.state.parserObject_getCountries, getOptionLabel:option => option.descr_el ? option.descr_el : "", }; }
      filterOptionsCountry = createFilterOptions({matchFrom: this.state.idIssuingCountry_AUTOCOMPLETE_FILTER_OPTIONS,stringify: (option) => option.descr_el + option.descr_en + option.keywords,});
    }

    var lang = localStorage.getItem("lang");
    var parserObject_getIdTypes4Picker       = (lang==="el") ? this.state.parserObject_getIdTypes4Picker_el   : this.state.parserObject_getIdTypes4Picker_en;
    var idType_text                          = this.translate_idtype(   lang,this.state.idType_id,         this.state.idType_text);
    //console.log(methName+"idType_text            = "+idType_text);
    //onsole.log(methName+"this.state.idType_id   = "+this.state.idType_id);
    //console.log(methName+"this.state.idType_text = "+this.state.idType_text);

    var newRegistrationFlow = "";
    try { newRegistrationFlow = localStorage.getItem("newRegistrationFlow"); } catch(err){;}

    var screen_title = this.NSInforString("RegisterLight3_title_newCustomer");
    if(newRegistrationFlow === "newCustomer")   { screen_title = this.NSInforString("RegisterLight3_title_newCustomer"); }
    if(newRegistrationFlow === "upgradeAccount"){ screen_title = this.NSInforString("RegisterLight3_title_upgradeAccount"); }
    if(newRegistrationFlow === "changeId")      { screen_title = this.NSInforString("RegisterLight3_title_changeId"); }

    var RegisterLight3_viewInfo_lbl_lbl1 = this.NSInforString("RegisterLight3_viewInfo_lbl_lbl1");
    if(this.state.btn_confirm_isHidden === false){ RegisterLight3_viewInfo_lbl_lbl1 = this.NSInforString("RegisterLight3_viewInfo_lbl_lbl1_retail"); }

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>

            {api.backButtonAtHeader === true ? (
              <GridContainer justify="center">
                <GridItem xs={2} sm={2} md={1}>
                  <div style={{ marginTop:20,marginBottom:10, textAlign:"left" }}>
                    {/* ----------[goBack]------------ */}
                    <Button style={{ backgroundColor:"#FFDD00" }} onClick={this.goBack}><KeyboardBackspaceIcon/></Button>
                  </div>
                </GridItem>
                <GridItem xs={10} sm={10} md={11}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{screen_title}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            ) : (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{screen_title}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            )}

            <div>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div className={classes.label1}>{RegisterLight3_viewInfo_lbl_lbl1}</div>
                  <div className={classes.label1}>{this.NSInforString("RegisterLight3_viewInfo_lbl_lbl2")}</div>
                  <div style={{ marginBottom:10 }}></div>
                </GridItem>
              </GridContainer>

              <GridContainer justify="center">
                {/* ------------------------- */}
                {/* ----------[HONEYMOON]---- */}
                {/* ------------------------- */}
                <GridItem xs={12} sm={12} md={12} className={classes.GridItemTextField0}>
                    <TextField
                      fullWidth
                      autoComplete={this.autoCompleteText_Textfields()}
                      error={this.state.textField0_hasError}
                      className={classes.textField0}
                      id={this.autoCompleteText_Textfields()}
                      label={this.autoCompleteText_Textfields()}
                      value={this.state.textField0}
                      InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField0"), type: "text" }}
                    />
                </GridItem>
                {/* ------------------------- */}
                {/* ----------ROW------------ */}
                {/* ------------------------- */}
                {this.state.idIssuingCountry_AUTOCOMPLETE_MODE === "text" ? (
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth className={classes.idIssuingCountry}>
                    <Autocomplete
                      {...defaultPropsCountry}
                      id="idIssuingCountry"
                      value={this.state.idIssuingCountry_text}
                      disableClearable
                      disabled={this.state.idIssuingCountry_disabled}
                      onChange={(event,value) => this.handleCustomDropDownClick_idIssuingCountry(event,value)}
                      renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(option).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option}</Typography></React.Fragment>);}}
                      renderInput={params => <TextField {...params} error={this.state.idIssuingCountry_hasError} label={this.NSInforString("RegisterLight3_plh02")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                    />
                  </FormControl>
                </GridItem>
                ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth className={classes.idIssuingCountry}>
                    <Autocomplete
                      filterOptions={filterOptionsCountry}
                      {...defaultPropsCountry}
                      id="idIssuingCountry"
                      value={this.state.idIssuingCountry_text}
                      disableClearable
                      disabled={this.state.idIssuingCountry_disabled}
                      onChange={(event,value) => this.handleCustomDropDownClick_idIssuingCountry(event,value)}
                      renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(option.descr_en).toLowerCase()+".png"]} alt="" width="26" height="17"/>&nbsp;&nbsp;{option.descr_en}</React.Fragment>);}}
                      renderInput={params => <TextField {...params} error={this.state.idIssuingCountry_hasError} label={this.NSInforString("RegisterLight3_plh02")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                    />
                  </FormControl>
                </GridItem>
                ) }
                {/* ------------------------- */}
                {/* ----------ROW------------ */}
                {/* ------------------------- */}
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.idType_hasError} className={classes.idType}>
                    <InputLabel id="idType_InputLabel">{this.NSInforString("RegisterLight3_plh03")}</InputLabel>
                    <Select
                      disabled={this.state.idType_disabled}
                      displayEmpty
                      id="idType"
                      value={idType_text+""}
                      onChange={event => this.handleCustomDropDownClick_idType(event)}
                    >
                      {parserObject_getIdTypes4Picker.map(function (akey) {
                        return <MenuItem key={akey} value={akey}>{akey}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
                {/* ------------------------- */}
                {/* ----------ROW------------ */}
                {/* ------------------------- */}
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error   ={this.state.idNumber_hasError}
                    disabled={this.state.idNumber_disabled}
                    className={classes.idNumber}
                    id="idNumber"
                    label={this.NSInforString("RegisterLight3_plh04")}
                    value={this.state.idNumber}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "idNumber"),
                      type: "text"
                    }}
                  />
                </GridItem>
              </GridContainer>
            </div>
            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}
            {/* ------------------------- */}
            {/* ----------[BUTTONS]------ */}
            {/* ------------------------- */}
            <div>
              {this.state.btn_confirm_isHidden === true ? ( "" ) : (
                <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    {/* <div className={classes.labelHeader}>&nbsp;</div> */}
                    <div className={classes.textCenter}>
                      {/* <ReCAPTCHA
                        ref={ ref => this.recaptchaRef = ref }
                        locale={localStorage.getItem("lang")}
                        sitekey={api.captchKey}
                        onResolved={ this.btn_confirm_act } /> */}
                      <CustomButton
                        disabled={this.btn_confirm_act_isDisabled()}
                        className={classes.yellowButton}
                        color="rose"
                        onClick={this.btn_confirm_act}
                        type="submit">
                        {this.NSInforString("RegisterLight3_btn_confirm") }
                      </CustomButton>
                    </div>
                  </GridItem>
                </GridContainer>
              )}
              {this.state.btn_changeId_isHidden === true ? ( "" ) : (
                <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    {/* <div className={classes.labelHeader}>&nbsp;</div> */}
                    <div className={classes.textCenter}>
                      {/* <ReCAPTCHA
                        ref={ ref => this.recaptchaRef = ref }
                        locale={localStorage.getItem("lang")}
                        sitekey={api.captchKey}
                        onResolved={ this.btn_changeId_act } /> */}
                      <CustomButton
                        disabled={this.btn_changeId_act_isDisabled()}
                        className={classes.grayButton}
                        color="rose"
                        onClick={this.btn_changeId_act}
                        type="submit">
                        {this.NSInforString("RegisterLight3_btn_changeId") }
                      </CustomButton>
                    </div>
                  </GridItem>
                </GridContainer>
              )}
              {this.state.btn_egov_isHidden === true ? ( "" ) : (
                <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    {/* <div className={classes.labelHeader}>&nbsp;</div> */}
                    <div className={classes.textCenter}>
                      {/* <ReCAPTCHA
                        ref={ ref => this.recaptchaRef = ref }
                        locale={localStorage.getItem("lang")}
                        sitekey={api.captchKey}
                        onResolved={ this.btn_egov_act } /> */}
                      <CustomButton
                        disabled={this.btn_egov_act_isDisabled()}
                        className={classes.yellowButton_gov}
                        color="rose"
                        onClick={this.btn_egov_act}
                        type="submit">
                        {this.NSInforString("RegisterLight3_btn_egov") }
                      </CustomButton>
                    </div>
                  </GridItem>
                </GridContainer>
              )}

              {this.state.btn_egov_isHidden === true ? ( "" ) : (
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.label11}>{this.NSInforString("RegisterLight3_lbl_egov_info")}</div>
                    <div style={{ marginBottom:20 }}></div>
                  </GridItem>
                </GridContainer>
              )}

              {this.state.btn_store_isHidden === true ? ( "" ) : (
                <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    {/* <div className={classes.labelHeader}>&nbsp;</div> */}
                    <div className={classes.textCenter}>
                      {/* <ReCAPTCHA
                        ref={ ref => this.recaptchaRef = ref }
                        locale={localStorage.getItem("lang")}
                        sitekey={api.captchKey}
                        onResolved={ this.btn_store_act } /> */}
                      <CustomButton
                        disabled={this.btn_store_act_isDisabled()}
                        className={classes.grayButton}
                        color="rose"
                        onClick={this.btn_store_act}
                        type="submit">
                        {this.NSInforString("RegisterLight3_btn_store") }
                      </CustomButton>
                    </div>
                  </GridItem>
                </GridContainer>
              )}
              {this.state.btn_next_isHidden === true ? ( "" ) : (
                <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    {/* <div className={classes.labelHeader}>&nbsp;</div> */}
                    <div className={classes.textCenter}>
                      {/* <ReCAPTCHA
                        ref={ ref => this.recaptchaRef = ref }
                        locale={localStorage.getItem("lang")}
                        sitekey={api.captchKey}
                        onResolved={ this.btn_next_act } /> */}
                      <CustomButton
                        disabled={this.btn_next_act_isDisabled()}
                        className={classes.yellowButton}
                        color="rose"
                        onClick={this.btn_next_act}
                        type="submit">
                        {this.NSInforString("RegisterLight3_btn_next") }
                      </CustomButton>
                    </div>
                  </GridItem>
                </GridContainer>
              )}
              {/* -------------------------------------------------- */}
              {/* ----------[goBack Bottom]------------------------- */}
              {/* -------------------------------------------------- */}
              {/* {api.backButtonAtBottom === true ? (
                <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    <div className={classes.textCenter}>
                      <CustomButton
                        disabled={false}
                        className={classes.backButton}
                        color="rose"
                        onClick={this.goBack}>
                        {this.NSInforString("RegisterLight3_btn_prev")}
                      </CustomButton>
                    </div>
                  </GridItem>
                </GridContainer>
              ) : ( "" ) } */}
            </div>

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        <GridContainer justify="center">
          <form id="govRedirectForm" action={api.url_onlinemt+api.webapp_path+"/gov/wbwu/redirect"} method="post">
            <GridItem xs={10} sm={10} md={10}>
              {/* GOV Payment info */}
              <input type="hidden" id="redirectURL"                    name="redirectURL"                    value={this.state.redirectURL}/>
              <input type="hidden" id="languageCode"                   name="languageCode"                   value={this.state.languageCode}/>
              {/* Session between domains : webapp & mobile */}
              <input type="hidden" id="platform"                       name="platform"                       value="webapp-react"/>
              <input type="hidden" id="accessToken"                    name="accessToken"                    value={localStorage.getItem("accessToken")}/>
              {/* Session between domains : webapp */}
              <input type="hidden" id="tokenID"                        name="tokenID"                        value={localStorage.getItem("tokenID")}/>
              <input type="hidden" id="refreshToken"                   name="refreshToken"                   value={localStorage.getItem("refreshToken")}/>
            </GridItem>
          </form>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------- */}
        {/* ----------[DialogSpinner]--- */}
        {/* ---------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_idIssuingCountry(event,value) {
    let methName = filename+"handleCustomDropDownClick_idIssuingCountry ";
    let event_target_value = null;
    let eventTMP1          = null;
    let eventTMP2          = null;
    if(this.state.idIssuingCountry_AUTOCOMPLETE_MODE === "text"){
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    }
    else{
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value.descr_en;
    }
    if(api.print_logs){console.log(methName+"eventTMP1 = " + eventTMP1);}
    if(api.print_logs){console.log(methName+"eventTMP2 = " + eventTMP2);}
    if(api.print_logs){console.log(methName+"event     = " + event);}
    if(api.print_logs){console.log(methName+"value     = " + value);}

    this.setState({
      "idIssuingCountry_text"     : eventTMP1,
      "idIssuingCountry_hasError" : false,
    });
    for(let i=0; i<this.state.parserObject_getCountries4Picker.length; ++i){
      if(this.state.parserObject_getCountries4Picker[i]===eventTMP2){
        this.setState({ "idIssuingCountry_id": this.state.parserObject_getCountries[i].ctry_wu_id });

        setTimeout(function() {
          this.buttons_show_hide();
          this.makeHTTPConn_select_COUNTRY_reload_IDTYPE(this.state.parserObject_getCountries[i].ctry_wu_id);
        }.bind(this), 500);
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_idType(event) {
    let methName = filename+"handleCustomDropDownClick_idType ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({ "idType_text" : eventTMP });
    if(localStorage.getItem("lang")==="el"){
      for(let i=0; i<this.state.parserObject_getIdTypes4Picker_el.length; ++i){
        if(this.state.parserObject_getIdTypes4Picker_el[i]===eventTMP){
          this.setState({
            "idType_id"               : this.state.parserObject_getIdTypes_el[i].id,
            "idType_hasError"         : false,
            "idType_idBox_kyc"        : this.state.parserObject_getIdTypes_el[i].idBox_kyc,
            "idType_idBox_kyc_isNull" : (this.state.parserObject_getIdTypes_el[i].idBox_kyc===null || (typeof this.state.parserObject_getIdTypes_el[i].idBox_kyc ==="undefined")) ? true : false,
          });
          break;
        }
      }
    }
    else{
      for(let i=0; i<this.state.parserObject_getIdTypes4Picker_en.length; ++i){
        if(this.state.parserObject_getIdTypes4Picker_en[i]===eventTMP){
          this.setState({
            "idType_id"               : this.state.parserObject_getIdTypes_en[i].id,
            "idType_hasError"         : false,
            "idType_idBox_kyc"        : this.state.parserObject_getIdTypes_en[i].idBox_kyc,
            "idType_idBox_kyc_isNull" : (this.state.parserObject_getIdTypes_en[i].idBox_kyc===null || (typeof this.state.parserObject_getIdTypes_en[i].idBox_kyc ==="undefined")) ? true : false,
          });
          break;
        }
      }
    }

    setTimeout(function() {
      this.buttons_show_hide();
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------CheckBox Listeners--------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------RadioButton Listeners-----------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  handleSubmit_with_recaptcha(event) {
    let methName = filename+"handleSubmit_with_recaptcha ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.idIssuingCountry_text === "")          { this.setState({"idIssuingCountry_hasError" : true }); emptyFields = true; } //idIssuingCountry_AUTOCOMPLETE_MODE(do not trim)
      if(this.state.idType_id === "")                      { this.setState({"idType_hasError"           : true }); emptyFields = true; }
      if(this.state.idNumber.trim() === "")                { this.setState({"idNumber_hasError"         : true }); emptyFields = true; }
      if(emptyFields===true){console.log("emptyFields===true");if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    event.preventDefault();
    if(this.btn_egov_act_isDisabled()){ console.log(methName+"reset");  this.recaptchaRef.reset();   }
    else                              { console.log(methName+"execute");this.recaptchaRef.execute(); }
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_confirm_act_isDisabled(){
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_confirm_act(event) {
    let methName = filename+"btn_confirm_act ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.idIssuingCountry_text === "")          { this.setState({"idIssuingCountry_hasError" : true }); emptyFields = true; } //idIssuingCountry_AUTOCOMPLETE_MODE(do not trim)
      if(this.state.idType_id === "")                      { this.setState({"idType_hasError"           : true }); emptyFields = true; }
      if(this.state.idNumber.trim() === "")                { this.setState({"idNumber_hasError"         : true }); emptyFields = true; }
      if(emptyFields===true){console.log("emptyFields===true");if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //---------------
    //validate idctry---Picker
    //---------------
    let idctry = this.state.idIssuingCountry_id;
    if(idctry  === ""){
      this.setState({"idIssuingCountry_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("RegisterLight3_plh02"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    if(this.state.idIssuingCountry_text === this.NSInforString("RegisterLight3_plh02")){
      this.setState({"idIssuingCountry_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("RegisterLight3_plh02"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //---------------
    //validate idtype---Picker
    //---------------
    let idtype = this.state.idType_id;
    if(idtype  === ""){
      this.setState({"idType_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("RegisterLight3_plh03"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //--------------
    //validate idnum---TextField
    //--------------
    let idnum = this.state.idNumber.trim();
    if(idnum  === ""){
      this.setState({"idNumber_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight3_plh04")+"\"");
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    try { localStorage.setItem("idBoxFlow",""); } catch(err){;}//confirm

    let parserObject_validatecustomer = {};
    try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
    var email = "";
    try {email = parserObject_validatecustomer["email"]; }catch(err){;} if(email === null){email = "";}

    var idNew = null;
         if(idtype===9000)  { idtype = 9; idNew = true;}
    else if(idtype===9)     { idtype = 9; idNew = false;}
         if(idtype==="9000"){ idtype = "9"; idNew = true;}
    else if(idtype==="9")   { idtype = "9"; idNew = false;}

    //event.preventDefault();
    let parserObject_updateCustomerData_req = {};
    parserObject_updateCustomerData_req["step"]               = "3";    //2
    parserObject_updateCustomerData_req["email"]              = email;  //lala@lala.com
    parserObject_updateCustomerData_req["idctry"]             = idctry; //GR
    parserObject_updateCustomerData_req["idtype"]             = idtype; //Identity_Card
    parserObject_updateCustomerData_req["idNew"]              = idNew;  //New Identity_Card
    parserObject_updateCustomerData_req["idnum"]              = idnum;  //A12345

    this.startSpinners();
    setTimeout(function() { //Start the timer
      //------------------
      //updateCustomerData
      //------------------
      wu_ProfileService
      .wu_updateCustomerData(parserObject_updateCustomerData_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="RegisterLight3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        //this.stopSpinners();
        //-------------------
        //wu_validatecustomer
        //-------------------
        wu_ProfileService
        .wu_validatecustomer({})
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="RegisterLight3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          //this.stopSpinners();
          localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));

          //+++++++++++++++
          //Goto Controller
          //+++++++++++++++
          localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
          history.push(wu_Utilities.getNavigationURLs("RegisterIdBoxSuccess")); //==> RegisterIdBoxSuccess
        })
        .catch(err => {
          this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
        });
      })
      .catch(err => {
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_changeId_act_isDisabled(){
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_changeId_act(event) {
    let methName = filename+"btn_changeId_act ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(emptyFields===true){console.log("emptyFields===true");if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    try { localStorage.setItem("idBoxFlow",""); } catch(err){;}//changeId
    //+++++++++++++++
    //Goto Controller
    //+++++++++++++++
    localStorage.setItem(filename.trim(), "");//Do nothing if---set
    history.push(wu_Utilities.getNavigationURLs("RegisterLight2"));
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_egov_act_isDisabled(){
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_egov_act(event) {
    let methName = filename+"btn_egov_act ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.idIssuingCountry_text === "")          { this.setState({"idIssuingCountry_hasError" : true }); emptyFields = true; } //idIssuingCountry_AUTOCOMPLETE_MODE(do not trim)
      if(this.state.idType_id === "")                      { this.setState({"idType_hasError"           : true }); emptyFields = true; }
      if(this.state.idNumber.trim() === "")                { this.setState({"idNumber_hasError"         : true }); emptyFields = true; }
      if(emptyFields===true){console.log("emptyFields===true");if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //---------------
    //validate idctry---Picker
    //---------------
    let idctry = this.state.idIssuingCountry_id;
    if(idctry  === ""){
      this.setState({"idIssuingCountry_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("RegisterLight3_plh02"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    if(this.state.idIssuingCountry_text === this.NSInforString("RegisterLight3_plh02")){
      this.setState({"idIssuingCountry_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("RegisterLight3_plh02"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //---------------
    //validate idtype---Picker
    //---------------
    let idtype = this.state.idType_id;
    if(idtype  === ""){
      this.setState({"idType_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("RegisterLight3_plh03"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //--------------
    //validate idnum---TextField
    //--------------
    let idnum = this.state.idNumber.trim();
    if(idnum  === ""){
      this.setState({"idNumber_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight3_plh04")+"\"");
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    try { localStorage.setItem("idBoxFlow","WorldBridgeekyc"); } catch(err){;}//egov

    let parserObject_validatecustomer = {};
    try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
    var email = "";
    try {email = parserObject_validatecustomer["email"]; }catch(err){;} if(email === null){email = "";}

    var idNew = null;
         if(idtype===9000)  { idtype = 9; idNew = true;}
    else if(idtype===9)     { idtype = 9; idNew = false;}
         if(idtype==="9000"){ idtype = "9"; idNew = true;}
    else if(idtype==="9")   { idtype = "9"; idNew = false;}

    //event.preventDefault();
    let parserObject_updateCustomerData_req = {};
    parserObject_updateCustomerData_req["step"]               = "3";    //2
    parserObject_updateCustomerData_req["email"]              = email;  //lala@lala.com
    parserObject_updateCustomerData_req["idctry"]             = idctry; //GR
    parserObject_updateCustomerData_req["idtype"]             = idtype; //Identity_Card
    parserObject_updateCustomerData_req["idNew"]              = idNew;  //New Identity_Card
    parserObject_updateCustomerData_req["idnum"]              = idnum;  //A12345

    this.startSpinners();
    setTimeout(function() { //Start the timer
      //---------------------
      //wu_updateCustomerData
      //---------------------
      wu_ProfileService
      .wu_updateCustomerData(parserObject_updateCustomerData_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="RegisterLight3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        //this.stopSpinners();
        //-------------------
        //wu_validatecustomer
        //-------------------
        wu_ProfileService
        .wu_validatecustomer({})
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="RegisterLight3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          //this.stopSpinners();
          localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));

          let parserObject_validatecustomer = {};
          try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
          var email = "";
          try {email = parserObject_validatecustomer["email"]; }catch(err){;} if(email === null){email = "";}

          //5A7,5A8 (RegisterLight3-egov)
          let customerLevel = wu_Utilities.textDecisions_customerLevel(api.print_logs,res.customer);
          var idVerificationStatus = 0;
          try {idVerificationStatus = res.customer["idVerificationStatus"]; }catch(err){;} if(idVerificationStatus !== null && (typeof idVerificationStatus !== "undefined")) {}
          if(customerLevel === "FULL" && (idVerificationStatus === 1 || idVerificationStatus === null)){
            //+++++++++++++++
            //Goto Controller
            //+++++++++++++++
            localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
            history.push(wu_Utilities.getNavigationURLs("RegisterIdBoxSuccess")); //==> RegisterIdBoxSuccess
            this.stopSpinners();
            return;
          }

          //--------------------
          //wu_idBoxAvailability
          //--------------------
          wu_RegisterIdBoxService
          .wu_idBoxAvailability({})
          .then(res => {
            if(localStorage.getItem("curr_view").trim()!=="RegisterLight3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
            if(api.print_logs){console.log(methName+"res.returnText="+res.returnText);}
            //-------------
            //egov_redirect
            //-------------
            wu_RegisterGOVService
            .wu_egov_redirect({email:email})
            .then(res => {
              if(localStorage.getItem("curr_view").trim()!=="RegisterLight3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
              /*this.stopLockers(); creates problem with double click thats why*/this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
              localStorage.setItem("parserObject_egov_redirect",JSON.stringify(res));

              let redirectURL       = "";
              let languageCode      = "";
              let parserObject_egov_redirect = null;
              try{ parserObject_egov_redirect = JSON.parse(localStorage.getItem("parserObject_egov_redirect"));} catch(err){;}
              try{ redirectURL       = parserObject_egov_redirect["url"]; }catch(err){redirectURL = "";}
              languageCode           = localStorage.getItem("lang")==="en" ? "en-US" : "el-GR";
              this.setState({
                redirectURL                                          : redirectURL,
                languageCode                                         : languageCode,
              });
              setTimeout(function() { //Start the timer
                if (typeof document.getElementById('govRedirectForm').submit === "object") {
                    document.getElementById('govRedirectForm').submit.remove();
                }
                document.getElementById('govRedirectForm').submit();
            //}.bind(this), 500);
              }.bind(), 500);
            })
            .catch(err => {
              /*this.stopLockers(); creates problem with double click thats why*/this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
              console.log(methName+"err="+JSON.stringify(err));
              if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){console.log("!!!!!!!!!!Logout("+filename+"-01)!!!!!!!!!!");wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
              else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
            });//wu_egov_redirect
          })
          .catch(err => {
            /*this.stopLockers(); creates problem with double click thats why*/this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
            console.log(methName+"err="+JSON.stringify(err));
            if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){console.log("!!!!!!!!!!Logout("+filename+"-01)!!!!!!!!!!");wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
            else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
          });//wu_idBoxAvailability
        })
        .catch(err => {
          this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
        });//wu_validatecustomer
      })
      .catch(err => {
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
      });//wu_updateCustomerData
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_store_act_isDisabled(){
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_store_act(event) {
    let methName = filename+"btn_store_act ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.idIssuingCountry_text === "")          { this.setState({"idIssuingCountry_hasError" : true }); emptyFields = true; } //idIssuingCountry_AUTOCOMPLETE_MODE(do not trim)
      if(this.state.idType_id === "")                      { this.setState({"idType_hasError"           : true }); emptyFields = true; }
      if(this.state.idNumber.trim() === "")                { this.setState({"idNumber_hasError"         : true }); emptyFields = true; }
      if(emptyFields===true){console.log("emptyFields===true");if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //---------------
    //validate idctry---Picker
    //---------------
    let idctry = this.state.idIssuingCountry_id;
    if(idctry  === ""){
      this.setState({"idIssuingCountry_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("RegisterLight3_plh02"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    if(this.state.idIssuingCountry_text === this.NSInforString("RegisterLight3_plh02")){
      this.setState({"idIssuingCountry_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("RegisterLight3_plh02"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //---------------
    //validate idtype---Picker
    //---------------
    let idtype = this.state.idType_id;
    if(idtype  === ""){
      this.setState({"idType_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("RegisterLight3_plh03"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //--------------
    //validate idnum---TextField
    //--------------
    let idnum = this.state.idNumber.trim();
    if(idnum  === ""){
      this.setState({"idNumber_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight3_plh04")+"\"");
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    try { localStorage.setItem("idBoxFlow",""); } catch(err){;}//next

    let parserObject_validatecustomer = {};
    try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
    var email      = "";
    var fname      = "";
    var lname      = "";
    var birth_date = "";
    try {email      = parserObject_validatecustomer["email"];      }catch(err){;} if(email      === null){email      = "";}
    try {fname      = parserObject_validatecustomer["fname"];      }catch(err){;} if(fname      === null){fname      = "";}
    try {lname      = parserObject_validatecustomer["lname"];      }catch(err){;} if(lname      === null){lname      = "";}
    try {birth_date = parserObject_validatecustomer["birth_date"]; }catch(err){;} if(birth_date === null){birth_date = "";}

    var idNew = null;
         if(idtype===9000)  { idtype = 9; idNew = true;}
    else if(idtype===9)     { idtype = 9; idNew = false;}
         if(idtype==="9000"){ idtype = "9"; idNew = true;}
    else if(idtype==="9")   { idtype = "9"; idNew = false;}

    //event.preventDefault();
    let parserObject_updateCustomerData_req = {};
    parserObject_updateCustomerData_req["step"]               = "store"; //3,store
    parserObject_updateCustomerData_req["email"]              = email;   //lala@lala.com
    parserObject_updateCustomerData_req["firstName"]          = fname;
    parserObject_updateCustomerData_req["lastName"]           = lname;
    parserObject_updateCustomerData_req["birthDate"]          = birth_date;
    parserObject_updateCustomerData_req["idctry"]             = idctry;  //GR
    parserObject_updateCustomerData_req["idtype"]             = idtype;  //Identity_Card
    parserObject_updateCustomerData_req["idNew"]              = idNew;  //New Identity_Card
    parserObject_updateCustomerData_req["idnum"]              = idnum;   //A12345

    this.startSpinners();
    setTimeout(function() { //Start the timer
      //------------------
      //updateCustomerData
      //------------------
      wu_ProfileService
      .wu_updateCustomerData(parserObject_updateCustomerData_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="RegisterLight3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        //this.stopSpinners();
        //-------------------
        //wu_validatecustomer
        //-------------------
        wu_ProfileService
        .wu_validatecustomer({})
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="RegisterLight3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          //this.stopSpinners();
          localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));

          //5A7,5A8(RegisterLight3-Store)
          let customerLevel = wu_Utilities.textDecisions_customerLevel(api.print_logs,res.customer);
          var idVerificationStatus = 0;
          try {idVerificationStatus = res.customer["idVerificationStatus"]; }catch(err){;} if(idVerificationStatus !== null && (typeof idVerificationStatus !== "undefined")) {}
          if(customerLevel === "FULL" && (idVerificationStatus === 1 || idVerificationStatus === null)){
            //+++++++++++++++
            //Goto Controller
            //+++++++++++++++
            localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
            history.push(wu_Utilities.getNavigationURLs("RegisterIdBoxSuccess")); //==> RegisterIdBoxSuccess
            this.stopSpinners();
            return;
          }

          //+++++++++++++++
          //Goto Controller
          //+++++++++++++++
          localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
          history.push(wu_Utilities.getNavigationURLs("RegisterLightStore"));
        })
        .catch(err => {
          this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
        });
      })
      .catch(err => {
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
      });
    }.bind(this), 500);
  }
  translate_idtype(lang,idType_id,idType_text){
    if(lang==="el"){
      for(let i=0; i<this.state.parserObject_getIdTypes_el.length; ++i){ if(this.state.parserObject_getIdTypes_el[i]["id"]===idType_id){ return this.state.parserObject_getIdTypes_el[i]["description"] } }
    }
    else{
      for(let i=0; i<this.state.parserObject_getIdTypes_en.length; ++i){ if(this.state.parserObject_getIdTypes_en[i]["id"]===idType_id){ return this.state.parserObject_getIdTypes_en[i]["descriptionEn"] } }
    }
    return "";
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_next_act_isDisabled(){
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_next_act(event) {
    let methName = filename+"btn_next_act ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.idIssuingCountry_text === "")          { this.setState({"idIssuingCountry_hasError" : true }); emptyFields = true; }
      if(this.state.idType_id === "")                      { this.setState({"idType_hasError" : true }); emptyFields = true; }
      if(this.state.idNumber.trim() === "")                { this.setState({"idNumber_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){console.log("emptyFields===true");if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //---------------
    //validate idctry---Picker
    //---------------
    let idctry = this.state.idIssuingCountry_id;
    if(idctry  === ""){
      this.setState({"idIssuingCountry_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("RegisterLight3_plh02"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    if(this.state.idIssuingCountry_text === this.NSInforString("RegisterLight3_plh02")){ //idIssuingCountry_AUTOCOMPLETE_MODE(do not trim)
      this.setState({"idIssuingCountry_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("RegisterLight3_plh02"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //---------------
    //validate idtype---Picker
    //---------------
    let idtype = this.state.idType_id;
    if(idtype  === ""){
      this.setState({"idType_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("RegisterLight3_plh03"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //--------------
    //validate idnum---TextField
    //--------------
    let idnum = this.state.idNumber.trim();
    if(idnum  === ""){
      this.setState({"idNumber_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight3_plh04")+"\"");
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    try { localStorage.setItem("idBoxFlow","WorldBridgeNoVideo"); } catch(err){;}//next

    let parserObject_validatecustomer = {};
    try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
    var email = "";
    try {email = parserObject_validatecustomer["email"]; }catch(err){;} if(email === null){email = "";}

    var idNew = null;
         if(idtype===9000)  { idtype = 9; idNew = true;}
    else if(idtype===9)     { idtype = 9; idNew = false;}
         if(idtype==="9000"){ idtype = "9"; idNew = true;}
    else if(idtype==="9")   { idtype = "9"; idNew = false;}

    //event.preventDefault();
    let parserObject_updateCustomerData_req = {};
    parserObject_updateCustomerData_req["step"]               = "3";    //2
    parserObject_updateCustomerData_req["email"]              = email;  //lala@lala.com
    parserObject_updateCustomerData_req["idctry"]             = idctry; //GR
    parserObject_updateCustomerData_req["idtype"]             = idtype; //Identity_Card
    parserObject_updateCustomerData_req["idNew"]              = idNew;  //New Identity_Card
    parserObject_updateCustomerData_req["idnum"]              = idnum;  //A12345

    this.startSpinners();
    setTimeout(function() { //Start the timer
      //------------------
      //updateCustomerData
      //------------------
      wu_ProfileService
      .wu_updateCustomerData(parserObject_updateCustomerData_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="RegisterLight3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        //this.stopSpinners();
        //-------------------
        //wu_validatecustomer
        //-------------------
        wu_ProfileService
        .wu_validatecustomer({})
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="RegisterLight3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          this.stopSpinners();
          localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));
          let parserObject_validatecustomer = {};
          try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
          var idVerificationStatus = 0;
          try {idVerificationStatus = parserObject_validatecustomer["idVerificationStatus"]; }catch(err){;} if(idVerificationStatus === null){idVerificationStatus = 0;}
          //nailed for testing:START
          //idVerificationStatus = 1;
          //nailed for testing:END

          //5A7,5A8(RegisterLight3-next)
          let customerLevel = wu_Utilities.textDecisions_customerLevel(api.print_logs,res.customer);
          var idVerificationStatus = 0;
          try {idVerificationStatus = res.customer["idVerificationStatus"]; }catch(err){;} if(idVerificationStatus !== null && (typeof idVerificationStatus !== "undefined")) {}
          if(customerLevel === "FULL" && (idVerificationStatus === 1 || idVerificationStatus === null)){
            //+++++++++++++++
            //Goto Controller
            //+++++++++++++++
            localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
            history.push(wu_Utilities.getNavigationURLs("RegisterIdBoxSuccess")); //==> RegisterIdBoxSuccess
            this.stopSpinners();
            return;
          }

          if(idVerificationStatus === 1 ){
            var btn_confirm_isHidden = false;
            var btn_store_isHidden   = true;
            var btn_egov_isHidden    = true;
            var btn_next_isHidden    = true;

            let ws_idnum   = "";
            let ws_id_ctry = "";
            let ws_idtype  = "";
            try {ws_idnum   = res.customer["idnum"];   }catch(err){;} if(ws_idnum   === null || (typeof ws_idnum   ==="undefined")){ws_idnum   = "";}
            try {ws_id_ctry = res.customer["id_ctry"]; }catch(err){;} if(ws_id_ctry === null || (typeof ws_id_ctry ==="undefined")){ws_id_ctry = "";}
            try {ws_idtype  = res.customer["idtype"];  }catch(err){;} if(ws_idtype  === null || (typeof ws_idtype  ==="undefined")){ws_idtype  = "";}

            this.setState({
              idIssuingCountry_id                                  : ws_id_ctry,
              idIssuingCountry_text                                : this.state.idIssuingCountry_AUTOCOMPLETE_MODE==="text" ? wu_Utilities.findCountryNameFromCountryId(ws_id_ctry,localStorage.getItem("lang")) : wu_Utilities.findCountryObjFromCountryId(ws_id_ctry,localStorage.getItem("lang")),
              idType_id                                            : "",
              idType_text                                          : "", //DropDown
              idType_hasError                                      : false,
              idType_idBox_kyc                                     : false,
              idType_idBox_kyc_isNull                              : false,
              "idNumber"                                           : ws_idnum,

              btn_confirm_isHidden                                 : btn_confirm_isHidden,
              btn_store_isHidden                                   : btn_store_isHidden,
              btn_egov_isHidden                                    : btn_egov_isHidden,
              btn_next_isHidden                                    : btn_next_isHidden,
            });

            this.makeHTTPConn_select_COUNTRY_reload_IDTYPE_select_IDTYPE(ws_id_ctry,ws_idtype);
          }
          else{
            //+++++++++++++++
            //Goto Controller
            //+++++++++++++++
            localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
            history.push(wu_Utilities.getNavigationURLs("RegisterLight4"));
          }
        })
        .catch(err => {
          this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
        });
      })
      .catch(err => {
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------makeHTTPConn--------------------------------------
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn_select_COUNTRY_reload_IDTYPE(idIssuingCountry_id){
      let methName = filename+"makeHTTPConn_select_COUNTRY_reload_IDTYPE ";

      if(idIssuingCountry_id===null || (typeof idIssuingCountry_id ==="undefined") || idIssuingCountry_id.trim()===""){
        return;
      }
      //-------------
      //wu_getIdTypes
      //-------------
      wu_IdentityCardsService
      .wu_getIdTypes({issuecountryid:idIssuingCountry_id})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="RegisterLight3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        var parserObject_getIdTypes4Picker_el = [];
        var parserObject_getIdTypes4Picker_en = [];
        let descKey_idTypes_el = "description"
        let descKey_idTypes_en = "descriptionEn";
        for(var i=0; i<res.idType.length; ++i){ parserObject_getIdTypes4Picker_el.push(res.idType[i][descKey_idTypes_el]); }
        for(var j=0; j<res.idType.length; ++j){ parserObject_getIdTypes4Picker_en.push(res.idType[j][descKey_idTypes_en]); }
        this.setState({ "parserObject_getIdTypes_el" : res.idType });
        this.setState({ "parserObject_getIdTypes_en" : res.idType });
        this.setState({
          "parserObject_getIdTypes4Picker_el" : parserObject_getIdTypes4Picker_el,
          "parserObject_getIdTypes4Picker_en" : parserObject_getIdTypes4Picker_en,
          "idType_id"                         : "",
          "idType_text"                       : "",
          "idType_hasError"                   : false,
          "idType_idBox_kyc"                  : false,
          "idType_idBox_kyc_isNull"           : false,
        });
      })
      .catch(err => {
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText,"NET"); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
      });

      return;
  }
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn_select_COUNTRY_reload_IDTYPE_select_IDTYPE(idIssuingCountry_id,idtype){
      let methName = filename+"makeHTTPConn_select_COUNTRY_reload_IDTYPE_select_IDTYPE ";

      if(api.print_logs){console.log(methName+"idIssuingCountry_id = "+idIssuingCountry_id); }
      if(api.print_logs){console.log(methName+"idtype              = "+idtype);              }

      if(idIssuingCountry_id==="" || (idIssuingCountry_id === null || (typeof idIssuingCountry_id ==="undefined")) ){
        console.log(methName+"return...idIssuingCountry_id = "+idIssuingCountry_id);
        return;
      }

      //let idtypeId = "";
      //-------------
      //wu_getIdTypes
      //-------------
      wu_IdentityCardsService
      .wu_getIdTypes({issuecountryid:idIssuingCountry_id})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="RegisterLight3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        if(res.returnCode===0){
          var parserObject_getIdTypes4Picker_el = [];
          var parserObject_getIdTypes4Picker_en = [];
          let descKey_idTypes_el = "description"
          let descKey_idTypes_en = "descriptionEn";
          for(var i=0; i<res.idType.length; ++i){ parserObject_getIdTypes4Picker_el.push(res.idType[i][descKey_idTypes_el]); }
          for(var j=0; j<res.idType.length; ++j){ parserObject_getIdTypes4Picker_en.push(res.idType[j][descKey_idTypes_en]); }
          this.setState({ "parserObject_getIdTypes_el" : res.idType });
          this.setState({ "parserObject_getIdTypes_en" : res.idType });
          this.setState({
            "parserObject_getIdTypes4Picker_el" : parserObject_getIdTypes4Picker_el,
            "parserObject_getIdTypes4Picker_en" : parserObject_getIdTypes4Picker_en,
            "idType_id"                         : "",
            "idType_text"                       : "",
            "idType_hasError"                   : false,
            "idType_idBox_kyc"                  : false,
            "idType_idBox_kyc_isNull   "        : false,
          });
          //---
          for(let i=0;  i<res.idType.length; ++i){
            if(idtype===res.idType[i]["description"] || idtype===res.idType[i]["descriptionEn"]){
              let descKey_idTypes = localStorage.getItem("lang")==="el" ? "description" : "descriptionEn";
              //idtypeId = res.idType[i]["id"];
              this.setState({
                "parserObject_getIdTypes4Picker_el" : parserObject_getIdTypes4Picker_el,
                "parserObject_getIdTypes4Picker_en" : parserObject_getIdTypes4Picker_en,
                "idType_id"                         : res.idType[i]["id"],
                "idType_text"                       : res.idType[i][descKey_idTypes],
                "idType_hasError"                   : false,
                "idType_idBox_kyc"                  : res.idType[i]["idBox_kyc"],
                "idType_idBox_kyc_isNull"           : (res.idType[i]["idBox_kyc"]===null || (typeof res.idType[i]["idBox_kyc"] ==="undefined")) ? true : false,
              });
            }
          }
          let numPages              = 2;
          let optionalMultiplePages = 0;
          for(let i=0; i<res.idType.length; ++i){
              try {numPages              = res.idType[i]["numPages"];              }catch(err){;} if(numPages              === null || (typeof numPages              ==="undefined")){numPages              = 2; }
              try {optionalMultiplePages = res.idType[i]["optionalMultiplePages"]; }catch(err){;} if(optionalMultiplePages === null || (typeof optionalMultiplePages ==="undefined")){optionalMultiplePages = 0; }
              if(idtype===res.idType[i]["description"] || idtype===res.idType[i]["descriptionEn"]){
                  if(api.print_logs){console.log(methName+"ScanDocuments_items_num             = "+numPages.toString());}
                  if(api.print_logs){console.log(methName+"ScanDocuments_optionalMultiplePages = "+optionalMultiplePages.toString());}
                  localStorage.setItem("ScanDocuments_items_num",numPages.toString());
                  localStorage.setItem("ScanDocuments_optionalMultiplePages",optionalMultiplePages.toString());
              }
          }
          setTimeout(function() {
            this.buttons_show_hide();
          }.bind(this), 500);
        }
      })
      .catch(err => {
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText,"NET"); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
      });

      return;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+eventTMP);}

    if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
      this.setState({"textField0":eventTMP.trim(),});
    }
    else if(stateVar==="idNumber"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "idNumber"            : eventTMP,
        "idNumber_hasError"   : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"idNumber_hasError":true}); return; }
    }
    else{
      this.setState({ [stateVar] : eventTMP });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  importAll(r) {
    //return r.keys().map(r);
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace('./', '')] = r(item);
      return "";
    });
    return images;
  }
  //----------------------------------------------------------------------------------------------------
  //https://stackoverflow.com/questions/21188420/javascript-date-validation-not-validation-february-31
  isValidDate(year, month, day) {
    let methName = filename+"isValidDate ";
    if(api.print_logs){console.log(methName);}

    try{
      let year_int  = parseInt(year);
      let month_int = parseInt(month)-1;
      let day_int   = parseInt(day);
      var d = new Date(year_int, month_int, day_int);
      //console.log(methName+"d.getFullYear()="+d.getFullYear()+" year_int="+year_int);
      //console.log(methName+"d.getMonth()   ="+d.getMonth()+"    month_int="+month_int);
      //console.log(methName+"d.getDate()    ="+d.getDate()+"     day_int="+day_int);
      if (d.getFullYear() === year_int && d.getMonth() === month_int && d.getDate() === day_int) {
          return true;
      }
    }catch(err){
      console.log(methName+"err="+err)
      return false;
    }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {
    //history.go(-1);
    history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Autocomplete--------------------------------------
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_autoCompleteDropDown(){
    return filename+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_Textfields(){
    //return filename+Math.random().toString().replace(/0\./g,"");
    //return filename.replace(/ /g,"")+Math.random().toString().replace(/0\./g,"");
    return Math.random().toString().replace(/0\./g,"")+"RG3"+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg,dType){
    if(dType==="NET"){
      setTimeout(function() {
        this.setState({
          "dialog_isOpen" : true,
          "dialog_msg"    : dialog_msg
        });
      }.bind(this), api.initialLoadGracePeriodMS);
      return;
    }
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Specific------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  buttons_show_hide() {
    let methName = filename+"buttons_show_hide ";
    if(api.print_logs){console.log(methName);}

    let parserObject_validatecustomer = {};
    try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
    var idVerificationStatus = 0;
    try {idVerificationStatus = parserObject_validatecustomer["idVerificationStatus"]; }catch(err){;} if(idVerificationStatus === null){idVerificationStatus = 0;}

    if(api.print_logs){console.log(methName+"this.state.idIssuingCountry_id     = "+this.state.idIssuingCountry_id);}
    if(api.print_logs){console.log(methName+"this.state.idType_text             = "+this.state.idType_text);}
    if(api.print_logs){console.log(methName+"this.state.idType_idBox_kyc        = "+this.state.idType_idBox_kyc);}
    if(api.print_logs){console.log(methName+"this.state.idType_idBox_kyc_isNull = "+this.state.idType_idBox_kyc_isNull);}

    let idIssuingCountry_disabled = false;
    let idType_disabled           = false;
    let idNumber_disabled         = false;
    let btn_confirm_isHidden  = true;
    let btn_changeId_isHidden = true;
    let btn_store_isHidden    = true;
    let btn_egov_isHidden     = true;
    let btn_next_isHidden     = true;
    //nailed for testing:START
    //idVerificationStatus = 1;
    //nailed for testing:END
    if(idVerificationStatus === 0 || idVerificationStatus === 2 || idVerificationStatus === null){
      idIssuingCountry_disabled = false;
      idType_disabled           = false;
      idNumber_disabled         = false;

      if(this.state.idType_idBox_kyc_isNull === true){
        btn_confirm_isHidden  = true;
        btn_changeId_isHidden = true;
        btn_store_isHidden    = false;
        btn_egov_isHidden     = true;
        btn_next_isHidden     = true;
      }
      else{
        if(this.state.idType_idBox_kyc === true){
          btn_confirm_isHidden  = true;
          btn_changeId_isHidden = true;
          btn_store_isHidden    = false;
          btn_egov_isHidden     = false;
          btn_next_isHidden     = true;
        }
        else{
          btn_confirm_isHidden  = true;
          btn_changeId_isHidden = true;
          btn_store_isHidden    = true;
          btn_egov_isHidden     = true;
          btn_next_isHidden     = false;
        }
      }
    }
    else{
      idIssuingCountry_disabled = true;
      idType_disabled           = true;
      idNumber_disabled         = true;

      btn_confirm_isHidden  = false;
      btn_changeId_isHidden = false;
      btn_store_isHidden    = true;
      btn_egov_isHidden     = true;
      btn_next_isHidden     = true;
    }
    this.setState({
      idIssuingCountry_disabled : idIssuingCountry_disabled,
      idType_disabled           : idType_disabled,
      idNumber_disabled         : idNumber_disabled,

      btn_confirm_isHidden      : btn_confirm_isHidden,
      btn_changeId_isHidden     : btn_changeId_isHidden,
      btn_store_isHidden        : btn_store_isHidden,
      btn_egov_isHidden         : btn_egov_isHidden,
      btn_next_isHidden         : btn_next_isHidden,
    });
  }
  //----------------------------------------------------------------------------------------------------
}
RegisterLight3.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(RegisterLight3Style)(RegisterLight3)
);
